var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-wrapper",domProps:{"innerHTML":_vm._s(_vm.svg)}},[_vm._v(" Icon ")])}
var staticRenderFns = []

export { render, staticRenderFns }